class ExtraCTA extends HTMLElement {
  /** @type HTMLButtonElement */
  button = null;
  /** @type HTMLFormElement */
  form = null;

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.button) return;

    this.button = document.createElement('button');
    this.button.innerHTML = this.innerHTML;
    this.innerHTML = '';
    this.appendChild(this.button);

    [...this.classList]
      .filter(className => className.startsWith('btn') || className.startsWith('button'))
      .forEach(className => {
        this.button.classList.add(className);
        this.classList.remove(className);
      });

    this.form = document.querySelector('product-form');

    this.button.addEventListener('click', this.click.bind(this));
    document.addEventListener('quick-cart:open', this.loaded.bind(this));
  }

  click() {
    if (this.form) {
      this.form.onSubmitHandler();
      this.button.classList.add('loading');
    }
  }

  loaded() {
    if (this.button) {
      this.button.classList.remove('loading');
    }
  }
}

customElements.define("extra-cta", ExtraCTA);
